import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const NotificationDialog = ({ notifView, isOpen, handleClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '24px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          overflow: 'hidden'
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          p: 3,
          position: 'relative'
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            pr: 4,
            color: 'white !important', // Force white color
            fontWeight: 600,
            fontSize: '1.25rem'
          }}
        >
          {notifView?.title || 'View Notification'}
        </DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: 'white',
            backgroundColor: 'rgba(255,255,255,0.1)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' }
          }}
          size='small'
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      </Box>

      {/* Content */}
      <DialogContent sx={{ p: 3, backgroundColor: '#f8fafc' }}>
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '16px',
            p: 3,
            minHeight: '150px',
            maxHeight: '50vh',
            overflowY: 'auto',
            '& p': {
              // Style any paragraph tags inside
              color: '#1e293b',
              marginBottom: '8px'
            }
          }}
        >
          {notifView?.description ? (
            <div dangerouslySetInnerHTML={{ __html: notifView.description }} />
          ) : (
            <Typography color='text.secondary'>No content available</Typography>
          )}
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions
        sx={{
          p: 2.5,
          borderTop: '1px solid #e9ecef',
          backgroundColor: 'white',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccessTimeIcon sx={{ fontSize: 16, color: '#94a3b8' }} />
          <Typography variant='body2' sx={{ color: '#64748b' }}>
            Received:{' '}
            <strong style={{ color: '#1e293b' }}>
              {notifView?.time || 'N/A'}
            </strong>
          </Typography>
        </Box>
        <Button
          variant='contained'
          onClick={handleClose}
          sx={{
            borderRadius: '12px',
            px: 3,
            py: 1,
            backgroundColor: '#2563eb',
            '&:hover': { backgroundColor: '#1d4ed8' },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationDialog;
